/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_Storage_TitleInputs */

const es_walkthrough_settings_storage_title = /** @type {(inputs: Walkthrough_Settings_Storage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento`)
};

const en_walkthrough_settings_storage_title = /** @type {(inputs: Walkthrough_Settings_Storage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Walkthrough_Settings_Storage_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_storage_title = /** @type {((inputs?: Walkthrough_Settings_Storage_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_Storage_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_storage_title(inputs)
	return en_walkthrough_settings_storage_title(inputs)
});
export { walkthrough_settings_storage_title as "walkthrough.settings_storage_title" }